import React from 'react'
import { Card } from '../../../../../../shared/card/card'
import { FormSimple } from '../../../../../../shared/form-simple/form'
import { FormSimpleText } from '../../../../../../shared/form-simple/form-text'
import { FormSimpleSubmitEdit } from '../../../../../../shared/form-simple/form-submit'

export const LoginDetails = ({ form }) => {
  const handleSubmit = data => form.put(data.id, data)

  return (
    <React.Fragment>
      <Card title="login">
        <FormSimple state={form.form} onSubmit={handleSubmit}>
          <FormSimpleText name="email" />
          <FormSimpleText name="firstName" />
          <FormSimpleText name="lastName" />
          <FormSimpleSubmitEdit />
        </FormSimple>
      </Card>
    </React.Fragment>
  )
}
